import { render, staticRenderFns } from "./IntegrationFortnox.vue?vue&type=template&id=a9d604b4&scoped=true"
import script from "./IntegrationFortnox.vue?vue&type=script&lang=js"
export * from "./IntegrationFortnox.vue?vue&type=script&lang=js"
import style0 from "./IntegrationFortnox.vue?vue&type=style&index=0&id=a9d604b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9d604b4",
  null
  
)

export default component.exports